module.exports = __webpack_public_path__ + "static/image-quote@2x-9bc5f1b136c126251f646562a0be1c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-quote@2x.jpg
// module id = 361
// module chunks = 3627797113349 20562973939449 33019919093843